var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"nopms"}},[_c('div',{staticClass:"head"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"f-content"},[_c('div',{staticClass:"fail"}),_c('div',{staticClass:"fail-msg"},[_vm._v("对不起！您当前无任何功能权限")]),_c('div',{staticClass:"fail-text"},[_vm._v("您可以联系系统管理员为您分配权限或者返回登录页用"),_c('br'),_vm._v("其他账号登录")])])])])
}]

export { render, staticRenderFns }